import { PickerPanel } from "./_picker";
import { TRIGGER_CATEGORIES } from "./_automation_data";

export default function TriggerPicker({ onClose, onPick }) {
  return <PickerPanel title="Add trigger" testId="trigger-picker"
    catalog={TRIGGER_CATEGORIES} onClose={onClose} onPick={onPick} />;
}
